import {
  SET_TRATO_CONFIGURADOR,
  SET_NOMBRE_CONFIGURADOR,
  SET_APELLIDO_MATERNO_CONFIGURADOR,
  SET_APELIIDO_PATERNO_CONFIGURADOR,
  SET_ESTADO_CONFIGURADOR,
  SET_CIUDAD_CONFIGURADOR,
  SET_ID_CONCESIONARIO_CONFIGURADOR,
  SET_CONCESIONARIO_CONFIGURADOR,
  SET_TELEFONO_CONFIGURADOR,
  SET_MOVIL_CONFIGURADOR,
  SET_CORREO_CONFIGURADOR,
  SET_COMENTARIOS_CONFIGURADOR,
  SET_AVISO_PRIVACIDAD_CONFIGURADOR,
  SET_TERMINOS_Y_CONDICIONES_CONFIGURADOR,
  SET_DATOS_1_CONFIGURADOR,
  SET_DATOS_2_CONFIGURADOR,
  SET_MODEL_INFO_CONFIGURADOR,
  RESET_STATE_CONFIGURADOR,
} from "../types";

/**
 * Función para reiniciar el state
 * @returns
 */
export function reiniciarStateAction() {
  return async (dispatch) => {
    dispatch({ type: RESET_STATE_CONFIGURADOR });
  };
}

/**
 *
 * @param {*} inTrato
 * @returns
 */
export function setTratoAction(inTrato) {
  return (dispatch) => {
    dispatch(setTrato(inTrato));
  };
}
const setTrato = (inTrato) => ({
  type: SET_TRATO_CONFIGURADOR,
  payload: inTrato,
});

/**
 *
 * @param {*} inNombre
 * @returns
 */
export function setNombreAction(inNombre) {
  return (dispatch) => {
    dispatch(setNombre(inNombre));
  };
}
const setNombre = (inNombre) => ({
  type: SET_NOMBRE_CONFIGURADOR,
  payload: inNombre,
});

/**
 *
 * @param {*} inApellidoPaterno
 * @returns
 */
export function setApellidoPaternoAction(inApellidoPaterno) {
  return (dispatch) => {
    dispatch(setApellidoPaterno(inApellidoPaterno));
  };
}
const setApellidoPaterno = (inApellidoPaterno) => ({
  type: SET_APELIIDO_PATERNO_CONFIGURADOR,
  payload: inApellidoPaterno,
});

/**
 *
 * @param {*} inApellidoMaterno
 * @returns
 */
export function setApellidoMaternoAction(inApellidoMaterno) {
  return (dispatch) => {
    dispatch(setApellidoMaterno(inApellidoMaterno));
  };
}
const setApellidoMaterno = (inApellidoMaterno) => ({
  type: SET_APELLIDO_MATERNO_CONFIGURADOR,
  payload: inApellidoMaterno,
});

/**
 *
 * @param {*} inTelefono
 * @returns
 */
export function setTelefonoAction(inTelefono) {
  return (dispatch) => {
    dispatch(setTelefono(inTelefono));
  };
}
const setTelefono = (inTelefono) => ({
  type: SET_TELEFONO_CONFIGURADOR,
  payload: inTelefono,
});

/**
 *
 * @param {*} inMovil
 * @returns
 */
export function setMovilAction(inMovil) {
  return (dispatch) => {
    dispatch(setMovil(inMovil));
  };
}
const setMovil = (inMovil) => ({
  type: SET_MOVIL_CONFIGURADOR,
  payload: inMovil,
});

/**
 *
 * @param {*} inCorreo
 * @returns
 */
export function setCorreoAction(inCorreo) {
  return (dispatch) => {
    dispatch(setCorreo(inCorreo));
  };
}
const setCorreo = (inCorreo) => ({
  type: SET_CORREO_CONFIGURADOR,
  payload: inCorreo,
});

/**
 *
 * @param {*} inEstado
 * @returns
 */
export function setEstadoAction(inEstado) {
  return (dispatch) => {
    dispatch(setEstado(inEstado));
  };
}
const setEstado = (inEstado) => ({
  type: SET_ESTADO_CONFIGURADOR,
  payload: inEstado,
});

/**
 *
 * @param {*} inCiudad
 * @returns
 */
export function setCiudadAction(inCiudad) {
  return (dispatch) => {
    dispatch(setCiudad(inCiudad));
  };
}
const setCiudad = (inCiudad) => ({
  type: SET_CIUDAD_CONFIGURADOR,
  payload: inCiudad,
});

/**
 *
 * @param {*} inIdConcesionario
 * @returns
 */
export function setIdConcesionarioAction(inIdConcesionario) {
  return (dispatch) => {
    dispatch(setIdConcesionario(inIdConcesionario));
  };
}
const setIdConcesionario = (inIdConcesionario) => ({
  type: SET_ID_CONCESIONARIO_CONFIGURADOR,
  payload: inIdConcesionario,
});

/**
 *
 * @param {*} inConcesionario
 * @returns
 */
export function setConcesionarioAction(inConcesionario) {
  return (dispatch) => {
    dispatch(setConcesionario(inConcesionario));
  };
}
const setConcesionario = (inConcesionario) => ({
  type: SET_CONCESIONARIO_CONFIGURADOR,
  payload: inConcesionario,
});

/**
 *
 * @param {*} inComentarios
 * @returns
 */
export function setComentariosAction(inComentarios) {
  return (dispatch) => {
    dispatch(setComentarios(inComentarios));
  };
}
const setComentarios = (inComentarios) => ({
  type: SET_COMENTARIOS_CONFIGURADOR,
  payload: inComentarios,
});

/**
 *
 * @param {*} inAvisosDePrivacidad
 * @returns
 */
export function setAvisosDePrivacidadAction(inAvisosDePrivacidad) {
  return (dispatch) => {
    dispatch(setAvisosDePrivacidad(inAvisosDePrivacidad));
  };
}
const setAvisosDePrivacidad = (inAvisosDePrivacidad) => ({
  type: SET_AVISO_PRIVACIDAD_CONFIGURADOR,
  payload: inAvisosDePrivacidad,
});

/**
 *
 * @param {*} inTerminosCondiciones
 * @returns
 */
export function setTerminosCondicionesAction(inTerminosCondiciones) {
  return (dispatch) => {
    dispatch(setTerminosCondiciones(inTerminosCondiciones));
  };
}
const setTerminosCondiciones = (inTerminosCondiciones) => ({
  type: SET_TERMINOS_Y_CONDICIONES_CONFIGURADOR,
  payload: inTerminosCondiciones,
});

/**
 *
 * @param {*} inDatos1
 * @returns
 */
export function setDatos1Action(inDatos1) {
  return (dispatch) => {
    dispatch(setDatos1(inDatos1));
  };
}
const setDatos1 = (inDatos1) => ({
  type: SET_DATOS_1_CONFIGURADOR,
  payload: inDatos1,
});

/**
 *
 * @param {*} inDatos2
 * @returns
 */
export function setDatos2Action(inDatos2) {
  return (dispatch) => {
    dispatch(setDatos2(inDatos2));
  };
}
const setDatos2 = (inDatos2) => ({
  type: SET_DATOS_2_CONFIGURADOR,
  payload: inDatos2,
});

/**
 *
 * @param {*} inModelInfo
 * @returns
 */
export function setModelInfoAction(inModelInfo) {
  return (dispatch) => {
    dispatch(setModelInfo(inModelInfo));
  };
}
const setModelInfo = (inModelInfo) => ({
  type: SET_MODEL_INFO_CONFIGURADOR,
  payload: inModelInfo,
});
